<template>
  <div style="clear: both;">
    <QuestionDocument
      :question="qa.question"
      :entryItems="entryItems"
      v-if="qa.question"
      @updated="updatedQuestion($event)"
    />
    <Answer
      :answer="qa.answer"
      :entryItems="entryItems"
      v-if="qa.answer"
      @updated="updatedAnswer($event)"
    />
  </div>
</template>

<script>
import Answer from "@/components/document/fill/block/qa/Answer";
import QuestionDocument from "@/components/document/fill/block/qa/QuestionDocument";
export default {
  name: "Qa",
  props: ["qa", "entryItems"],
  components: {
    Answer,
    QuestionDocument
  },
  methods: {
    updatedQuestion(event) {
      // let copy = Object.assign({}, this.listElement);
      let copy = JSON.parse(JSON.stringify(this.qa));
      copy.question = event;
      this.$emit("updated", copy);
    },
    updatedAnswer(event) {
      // let copy = Object.assign({}, this.listElement);
      let copy = JSON.parse(JSON.stringify(this.qa));
      copy.answer = event;
      this.$emit("updated", copy);
    }
  }
};
</script>
